<template>
    <div>
        <GridPage
            :form-default="{
                status: '',
            }"
            :filters-default="{
                status: '',
                sort: 'name',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '下書き', value: 'draft' },
                        { text: '出品中', value: 'listed' },
                        { text: '取引中', value: 'sold' },
                        { text: '売却済', value: 'completed' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        {
                            text: '▲ 名前',
                            value: 'name',
                        },
                        { text: '▼ 名前', value: '-name' },
                    ],
                },
            ]"
            filters-q-placeholder="名前"
            form-modal-id="store"
            search-action="store/index"
            :hide-header="true"
            >
            <template v-slot:form="{ form, init }">
                <Store :model="form" :init="init"></Store>
            </template>

            <template v-slot:column="{ item }">
<b-col>
                <div class="d-flex flex-wrap bd-highlight">
                    <div class="p-2 flex-shrink-1 bd-highlight">
                        <ItemThumb :model="item" class="mb-1" />
                    </div>
                    <div class="p-2 flex-grow-1 bd-highlight">

<b-row class="no-gutters">
                <b-col md="6" class="align-self-center">
<!--
                    <ItemBadges :model="item" class="mb-1" />
-->
    
                    <p class="mb-1 font-weight-bold">
                        {{ item.name }}
                    </p>

<!--
                    <div class="mb-1">
                        {{ item.price | baseNumberFormatter }}
                        <template v-if="item.price2"> - {{ item.price2 | baseNumberFormatter }}</template>
                    </div>
-->
                </b-col>
    
                <b-col md="6" class="align-self-center">
                    <StoreInfo :model="item" />
                </b-col>
</b-row>

                    </div>
                </div>
</b-col>
            </template>
        </GridPage>
<!--
        <b-link :href="`/f/${auth_uuid}/`" target="_blank">
            公開ページを表示する
            <font-awesome-icon class="fa-fw" icon="external-link-alt" />
        </b-link>
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Store from '@/components/Store.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import FormDate from '@/components/FormDate.vue'
import StoreInfo from '@/components/StoreInfo.vue'

export default {
    components: {
        GridPage,
        Store,
        ItemBadges,
        ItemThumb,
        FormDate,
        StoreInfo,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
    },
}
</script>

